import { TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import React from "react";

import { DashboardCard } from "../components/Card";
import CardSpacer from "../components/CardSpacer";
import { ResponsiveTable } from "../components/ResponsiveTable";

type ProductRow = {
  name: string;
  qty: number;
  vendorPrice: number;
  totalVendorPrice: number;
  originalPrice: number;
  totalOriginalPrice: number;
  margin: number;
};

type VendorReport = {
  vendorName: string;
  products: ProductRow[];
};

const currency = (value: number) =>
  `LRD ${value.toLocaleString(undefined, { minimumFractionDigits: 2 })}`;

const vendors: VendorReport[] = [
  {
    vendorName: "Ivory Coast Rubber Items",
    products: [
      {
        name: "Bibas short drum",
        qty: 2,
        vendorPrice: 500,
        totalVendorPrice: 1000,
        originalPrice: 750,
        totalOriginalPrice: 1500,
        margin: 500,
      },
    ],
  },
  {
    vendorName: "Fayid Enterprise",
    products: [
      {
        name: "Crown Vitae",
        qty: 1,
        vendorPrice: 5985,
        totalVendorPrice: 5985,
        originalPrice: 6250,
        totalOriginalPrice: 6250,
        margin: 265,
      },
    ],
  },
  {
    vendorName: "FOUANI Business",
    products: [
      {
        name: "VEGETABLE OIL",
        qty: 7,
        vendorPrice: 5890,
        totalVendorPrice: 41230,
        originalPrice: 5980,
        totalOriginalPrice: 41860,
        margin: 630,
      },
    ],
  },
  {
    vendorName: "Jungle Water",
    products: [
      {
        name: "Flour Baker Choice-25KG",
        qty: 3,
        vendorPrice: 4067,
        totalVendorPrice: 12201,
        originalPrice: 4250,
        totalOriginalPrice: 12750,
        margin: 549,
      },
    ],
  },
];

const totals = {
  sales: 62360,
  purchased: 60416,
  margin: 1944,
};

const cpdc = () => {
  return (
    <div style={{ margin: "20px" }}>
      {/* Totals */}
      <div style={{ display: "flex", gap: "50px" }}>
        <DashboardCard>
          <Typography variant="caption">Total Sales (Original Prices)</Typography>
          <Typography variant="h6">{currency(totals.sales)}</Typography>
        </DashboardCard>
        <DashboardCard>
          <Typography variant="caption">Total Purchased (Vendor Prices)</Typography>
          <Typography variant="h6">{currency(totals.purchased)}</Typography>
        </DashboardCard>
        <DashboardCard>
          <Typography variant="caption" color="error">
            Gross Margin
          </Typography>
          <Typography variant="h6" color="error">
            {currency(totals.margin)}
          </Typography>
        </DashboardCard>
      </div>
      <CardSpacer />

      {/* Vendors */}
      {vendors.map(vendor => {
        const grandTotals = vendor.products.reduce(
          (acc, p) => {
            acc.vendor += p.totalVendorPrice;
            acc.original += p.totalOriginalPrice;
            acc.margin += p.margin;

            return acc;
          },
          { vendor: 0, original: 0, margin: 0 },
        );

        return (
          <React.Fragment key={vendor.vendorName}>
            <DashboardCard>
              <Typography variant="h6">Vendor: {vendor.vendorName}</Typography>

              <ResponsiveTable>
                <TableHead>
                  <TableRow>
                    <TableCell>Product</TableCell>
                    <TableCell>Qty</TableCell>
                    <TableCell>Vendor Price</TableCell>
                    <TableCell>Total Vendor</TableCell>
                    <TableCell>Original Price</TableCell>
                    <TableCell>Total Original</TableCell>
                    <TableCell>Margin</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {vendor.products.map((p, idx) => (
                    <TableRow key={idx}>
                      <TableCell>{p.name}</TableCell>
                      <TableCell>{p.qty}</TableCell>
                      <TableCell>{currency(p.vendorPrice)}</TableCell>
                      <TableCell>{currency(p.totalVendorPrice)}</TableCell>
                      <TableCell>{currency(p.originalPrice)}</TableCell>
                      <TableCell>{currency(p.totalOriginalPrice)}</TableCell>
                      <TableCell>{currency(p.margin)}</TableCell>
                    </TableRow>
                  ))}

                  <TableRow>
                    <TableCell colSpan={3}>
                      <strong>Grand Total</strong>
                    </TableCell>
                    <TableCell>
                      <strong>{currency(grandTotals.vendor)}</strong>
                    </TableCell>
                    <TableCell />
                    <TableCell>
                      <strong>{currency(grandTotals.original)}</strong>
                    </TableCell>
                    <TableCell>
                      <strong>{currency(grandTotals.margin)}</strong>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </ResponsiveTable>
            </DashboardCard>

            <CardSpacer />
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default cpdc;
